/*
 * 首页模块接口
 */

import { post, get,  put, del } from 'api/http'

export default {
    // 我的待办
    getMyDoing(data) {
        // return get('/app/my/doing/count', data)
        return get('/wx/userAnnouncement/getMyDoing', data, 'javaHost')
    },

    // 消息代办数量
    myMessageCount(data) {
        // return get('/app/user/announcement/count', data)
        return get('/wx/userAnnouncement/getDoingCount', data, 'javaHost')
    },

    // 代办事项列表
    getDoingList(data) {
        // return get('/app/my/doing', data)
        return get('/wx/userAnnouncement/findDoing', data, 'javaHost')
    }
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/myMessage.js